export const manifest = {
  screens: {
    scr_wm77nq: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_l70s9t: { name: "Trust Framework", route: "/agreexa-trust-framework", position: {"x":2960,"y":6160} },
    scr_n3idkh: { name: "Buying Guides", route: "/buying-guides", position: {"x":160,"y":6160} },
    scr_d48pjl: { name: "Reviews", route: "/reviews", position: {"x":160,"y":2200} },
    scr_2v86i2: { name: "Review Detail", route: "/reviews/solar-generator", position: {"x":1560,"y":2200} },
    scr_fde2g2: { name: "Energy", route: "/energy", position: {"x":160,"y":4180} },
    scr_9pq5ve: { name: "Preparedness", route: "/preparedness", position: {"x":1560,"y":4180} },
    scr_qf0isd: { name: "Water", route: "/water", position: {"x":2960,"y":4180} },
    scr_toyv0y: { name: "Smart Home", route: "/smart-home", position: {"x":4360,"y":4180} },
    scr_glwps7: { name: "Research", route: "/research", position: {"x":1560,"y":6160} },
    scr_gc5b0o: { name: "About", route: "/about", position: {"x":160,"y":8140} },
    scr_bk9ll6: { name: "Contact", route: "/contact", position: {"x":1560,"y":8140} },
  },
  sections: {
    sec_0usu4k: { name: "Home", x: 0, y: 0, width: 1520, height: 1180 },
    sec_d7h8kl: { name: "Reviews flow", x: 0, y: 1980, width: 2920, height: 1180 },
    sec_g1y4f3: { name: "Topic Categories", x: 0, y: 3960, width: 5720, height: 1180 },
    sec_0jfbii: { name: "Content & Resources", x: 0, y: 5940, width: 4320, height: 1180 },
    sec_vjr6z6: { name: "Footer Navigation", x: 0, y: 7920, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_0usu4k", children: [
      { kind: "screen", id: "scr_wm77nq" },
    ] },
    { kind: "section", id: "sec_d7h8kl", children: [
      { kind: "screen", id: "scr_d48pjl" },
      { kind: "screen", id: "scr_2v86i2" },
    ] },
    { kind: "section", id: "sec_g1y4f3", children: [
      { kind: "screen", id: "scr_fde2g2" },
      { kind: "screen", id: "scr_9pq5ve" },
      { kind: "screen", id: "scr_qf0isd" },
      { kind: "screen", id: "scr_toyv0y" },
    ] },
    { kind: "section", id: "sec_0jfbii", children: [
      { kind: "screen", id: "scr_n3idkh" },
      { kind: "screen", id: "scr_glwps7" },
      { kind: "screen", id: "scr_l70s9t" },
    ] },
    { kind: "section", id: "sec_vjr6z6", children: [
      { kind: "screen", id: "scr_gc5b0o" },
      { kind: "screen", id: "scr_bk9ll6" },
    ] },
  ],
}
